import $axios from '~/plugins/axios';
import { buildModule } from '../utils';
import { Api, CustomField, GetCustomFieldParams } from '~/api';
import { createDict, Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedCustomFields: {} as Dict<CustomField>,
		customFields: [] as CustomField[],
	})
	.withGetters({
		byId: state => (customFieldId: number): CustomField | null => (
			state.storedCustomFields[customFieldId] ?? null
		),
		items: state => state.customFields,
	})
	.withMutations({
		SET_STORED_CUSTOM_FIELDS (state, customFields: CustomField[]) {
			state.storedCustomFields = {
				...state.storedCustomFields,
				...createDict(customFields, (customField) => customField.id),
			};
		},
		SET_CUSTOM_FIELDS (state, customFieldIds: number[]) {
			state.customFields = customFieldIds.map(id => state.storedCustomFields[id]);
		},
	})
	.withActions({
		async get ({ commit }, params: GetCustomFieldParams) {
			const { data } = await api.get('/custom-field', { params });

			const customFields = data.payload;
			const customFieldIds = customFields.map(customField => customField.id);

			commit('SET_STORED_CUSTOM_FIELDS', customFields);
			commit('SET_CUSTOM_FIELDS', customFieldIds);
		},
	});

